/***
**Module Name: footer
**File Name : footer
**Project : Dadi
**Copyright(c) : X Platform Consulting.
**Organization : Peafowl Inc
**author : Kiran Kumar
**author : Mani Kanta
**license :
**version : 1.0.0
**Created on :
**Created on: 2025-04-22
**Last modified on: Dec 29 2022
**Description : contains Footer details.
***/
import { colors } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";



const Footer = () => {
    const navigate = useNavigate();
    const handelnavigation = (route) => {

        navigate(route)

    }



    return (
        <>


            <footer className="footer">
                <div className="container-fluid">
                    <div className="menu_section">
                        <div className="footer-menu">
                        <a onClick={(e) => handelnavigation("/diagnostics")}>Diagnostics</a>
                        <a onClick={(e) => handelnavigation("/learning")}>Learning Hub</a>
                        <a onClick={(e) => handelnavigation("/cpcregistration")}>CPC</a>
                        <a onClick={(e) => handelnavigation("/fellowship")}>Fellowship</a>
                        <a onClick={(e) => handelnavigation("/about")}>About</a>
                        <a onClick={(e) => handelnavigation("/contact")}>Contact</a>
                        </div>
                        <div className="footer-bottom db-footer-bottom text-center mt-4 pb-3">
                          <div className="container pb-0 d-flex align-items-center">
                            <div className="legal-links d-flex">
                              <p>
                                Copyright © {new Date().getFullYear()} <strong>DADI</strong>. All rights reserved
                              </p>
                              <Link to="/privacy">Privacy</Link>
                              <Link to="/terms">Terms of Use</Link>
                            </div>
                            <p className="brandName" style={{ color: "#212529", fontWeight: "bold", marginLeft: "auto" }}>
                              Powered By <a target="_blank" href="https://www.sanchaninfo.com/" style={{ color: "#212529", fontWeight: "bold", textDecoration: "none" }}>Sanchan Info Solutions</a>
                            </p>
                          </div>
                        </div>
                    </div>
                        
                </div>
            </footer>


        </>
    );
};

export default Footer;